// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jb0X","content":"styles_content__2IRjn","checkbox":"styles_checkbox__21bk0","checkboxLabel":"styles_checkboxLabel__1b6H9"};